import HttpService from "@core/services/http/http.service";
import { CreateVoucher, CreateVoucherBook, CreateVoucherKas } from "@app/types";
import { RequestContentType } from "@core/services/http/http.type";

class _VoucherService {
  public create(createVoucher: CreateVoucher) {
    return HttpService.post("/admin/api/v2/vouchers/import", {
      body: { ...createVoucher },
      requestContentType: RequestContentType.MULTIPART,
    });
  }

  public createVoucherBook(createVoucherBook: CreateVoucherBook) {
    return HttpService.post("/admin/api/v2/voucher-book/import", {
      body: { ...createVoucherBook },
      requestContentType: RequestContentType.MULTIPART,
    });
  }

  public createVoucherKas(createVoucherKas: CreateVoucherKas) {
    return HttpService.post("/admin/api/v2/voucher-kas/import", {
      body: { ...createVoucherKas },
      requestContentType: RequestContentType.MULTIPART,
    });
  }

}

const VoucherService = new _VoucherService();

export default VoucherService;
